import { render, staticRenderFns } from "./MainPerformance.vue?vue&type=template&id=7be70ad6&scoped=true"
import script from "./MainPerformance.vue?vue&type=script&lang=js"
export * from "./MainPerformance.vue?vue&type=script&lang=js"
import style0 from "./MainPerformance.vue?vue&type=style&index=0&id=7be70ad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be70ad6",
  null
  
)

export default component.exports